export const SAVE_TEMPORARY_ITEM = 'SAVE_TEMPORARY_ITEM';

export const saveTemporaryItem = context => ({
  type: SAVE_TEMPORARY_ITEM,
  context,
});
